import { useMemo } from 'react';
import { useForm } from '@shared/hooks';
import type { SignupRequest } from '@shared/api/rest/auth';

export default function useSignup() {
  const title = 'Sign Up';
  const fields = useMemo(
    () => ({
      companyCode: {
        name: 'companyCode',
        caption: 'Company Code',
        required: 'Company Code is required',
        error: 'Company Code is required',
      },
      password: {
        name: 'password',
        caption: 'Password',
        required: 'Password is required',
        error: 'Password is required',
      },
    }),
    [
      /* translation? */
    ],
  );
  return useForm<SignupRequest>({ title, fields });
}
